module.exports = __webpack_public_path__ + "static/media/icon-pinterest.c557c3d4.svg";